import { useEffect, useState } from "react";
import { calcSurebetBonusFromBets, calcNormalSurebet, stakeChanger, riskFreeBettingFormula, surebetLockedValueFormula } from "../../utils/calculator/formulas";
import { ContextCalculatorUser } from "../../context/ContextCalculatorUser";
import Desktop from "./responsive/User/Desktop";
import Mobile from "./responsive/User/Mobile";
import { useMediaQuery } from "react-responsive";
import { parseBrazilianNumber, IsNumber } from "../../utils/calculator/formatNumberValidator";
function User(props) {
  const {
    setProfitSurebet,
    budget,
    setBudget,
    roundTo,
    roundingEnabled,
    selectedBookmaker,
    setEditingValues,
    setRoundTo,
    setEditingRoundTo,
    editingValues,
    valueIsUnacceptable,
    setValueIsUnacceptable,
    setRoundingEnabled,
    setSelectedBookmaker
  } = ContextCalculatorUser();
  const {
    dataOperation,
    setDataOperation,
    formData,
    typeSurebet,
    settingsCalculator,
    bonusValue,
    bonusProportionValue
  } = props;
  const [isBlockedFieldsCash, setIsBlockedFieldsCash] = useState(false);
  const [lockedValue, setLockedValue] = useState(+dataOperation.reduce((total, item, index) => index >= 2 ? total : item.stake + total, 0).toFixed(2));
  const isMobile = useMediaQuery({ maxWidth: 650 });
  const indexBookmakerBonus = 0;
  const calculateSurebet = ({ paramBudget = budget, paramRoundTo = roundTo, paramRoundingEnabled = roundingEnabled, paramBookmakers = dataOperation } = {}) => {
    const resultCalcNormalSurebet = calcNormalSurebet(paramBudget, paramRoundTo, paramRoundingEnabled, paramBookmakers);
    setProfitSurebet(resultCalcNormalSurebet["profit"]);
    setDataOperation(resultCalcNormalSurebet["dataOperation"]);
  };
  const stakeChangeNormalSurebet = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0, paramBookmakers = dataOperation, paramSelectedBookmaker = selectedBookmaker, paramRoundingEnabled = roundingEnabled, paramRoundTo = roundTo) => {
    const resultCalcStake = stakeChanger(index, value, paramSelectedBookmaker, paramRoundingEnabled, paramRoundTo, paramBookmakers, canChangeStake, skipUpateBackStake, backStake);
    setBudget(resultCalcStake["budget"]);
    setDataOperation(resultCalcStake["dataOperation"]);
    if (resultCalcStake["canUpdateProfit"] === true) {
      setProfitSurebet(resultCalcStake["profit"]);
    }
  };
  const stakeChangeLockedValue = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0, paramBookmakers = dataOperation, paramRoundingEnabled = roundingEnabled, paramRoundTo = roundTo) => {
    const resultCalcStake = stakeChanger(index, value, index, paramRoundingEnabled, paramRoundTo, paramBookmakers, canChangeStake, skipUpateBackStake, backStake);
    setBudget(resultCalcStake["budget"]);
    setDataOperation(resultCalcStake["dataOperation"]);
    if (resultCalcStake["canUpdateProfit"] === true) {
      setProfitSurebet(resultCalcStake["profit"]);
    }
    if (resultCalcStake["dataOperation"].length >= 2) {
      let stake1 = resultCalcStake["dataOperation"][0]["stake"];
      let stake2 = resultCalcStake["dataOperation"][1]["stake"];
      let newLockedValue = +(stake1 + stake2).toFixed(2);
      setLockedValue(newLockedValue);
    }
  };
  const manageSurebetLockedValueFormula = ({
    paramLockedValue = lockedValue,
    paramBookmakers = dataOperation,
    paramRoundingEnabled = roundingEnabled,
    paramRoundTo = roundTo
  } = {}) => {
    const clonedParamBookmakers = structuredClone(paramBookmakers);
    const resultLockedValueSurebet = surebetLockedValueFormula(paramLockedValue, clonedParamBookmakers, paramRoundingEnabled, paramRoundTo);
    setBudget(resultLockedValueSurebet["budget"]);
    setDataOperation(resultLockedValueSurebet["dataOperation"]);
    if (resultLockedValueSurebet["canUpdateProfit"] === true) {
      setProfitSurebet(resultLockedValueSurebet["profit"]);
    }
  };
  const managerCalcRiskFreeBettingFormula = ({
    value = dataOperation.length > 0 ? dataOperation[0]["stake"] : 0,
    paramBookmakers = dataOperation,
    paramRoundingEnabled = roundingEnabled,
    paramRoundTo = roundTo,
    paramBonusValue = bonusValue,
    paramConversionBonusValue = bonusProportionValue
  } = {}) => {
    let resultRiskFreeBettingFormula = riskFreeBettingFormula(value, paramBookmakers, paramRoundingEnabled, paramRoundTo, paramBonusValue, paramConversionBonusValue);
    setBudget(resultRiskFreeBettingFormula["budget"]);
    setDataOperation(resultRiskFreeBettingFormula["dataOperation"]);
  };
  const managerCalcSurebetPinnedStake = (paramBookmakers) => {
    if (selectedBookmaker >= 0) {
      stakeChangeNormalSurebet(selectedBookmaker, paramBookmakers[selectedBookmaker]["stake"], false, false, 0, paramBookmakers, selectedBookmaker, roundingEnabled, roundTo);
    } else {
      calculateSurebet({ "paramBookmakers": paramBookmakers });
    }
  };
  const handleStakeChange = (index, value, canChangeStake = false, skipUpateBackStake = false, backStake = 0) => {
    if (typeSurebet === "bonus_bookmaker" && index === indexBookmakerBonus) {
      const updated = [...dataOperation];
      updated[indexBookmakerBonus]["stake"] = value;
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting" && index === indexBookmakerBonus) {
      const updated = [...dataOperation];
      updated[indexBookmakerBonus]["stake"] = value;
      managerCalcRiskFreeBettingFormula({ value: updated[indexBookmakerBonus]["stake"], paramBookmakers: updated });
    } else if (typeSurebet === "locked_value" && index >= 0 && index <= 1) {
      stakeChangeLockedValue(index, value, canChangeStake, skipUpateBackStake, backStake);
    } else if (typeSurebet === "") {
      stakeChangeNormalSurebet(index, value, canChangeStake, skipUpateBackStake, backStake);
    }
  };
  const handleChanceChange = (index, value) => {
    const updated = [...dataOperation];
    updated[index]["chance"] = value;
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting") {
      if (updated.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramBookmakers: updated });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: updated });
    } else if (typeSurebet !== "bonus_bookmaker") {
      managerCalcSurebetPinnedStake(updated);
    }
  };
  function calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker = dataOperation, paramRoundTo = roundTo, paramRoundingEnabled = roundingEnabled, skipUpateBackStake = false } = {}) {
    let resultOperationFreeBookmaker = calcSurebetBonusFromBets(dataOperationFreeBookmaker[0]["stake"], dataOperationFreeBookmaker, indexBookmakerBonus, paramRoundTo, paramRoundingEnabled, skipUpateBackStake);
    setDataOperation(resultOperationFreeBookmaker);
    const newBudget = resultOperationFreeBookmaker.reduce(
      (sum, operation, i) => i === indexBookmakerBonus ? sum : sum + operation.stake,
      0
    );
    setBudget(+newBudget.toFixed(2));
  }
  useEffect(() => {
    const roundIsSelectedStored = settingsCalculator.current.roundIsSelected;
    const roundValueStored = settingsCalculator.current.roundValue;
    const indexBookmakerSelectedStored = settingsCalculator.current.indexBookmakerSelected;
    setRoundingEnabled(roundIsSelectedStored);
    setRoundTo(roundValueStored);
    setSelectedBookmaker(indexBookmakerSelectedStored);
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ paramRoundTo: roundValueStored, paramRoundingEnabled: roundIsSelectedStored });
    } else if (typeSurebet === "risk_free_betting") {
      managerCalcRiskFreeBettingFormula({ paramRoundingEnabled: roundIsSelectedStored, paramRoundTo: roundValueStored });
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramRoundingEnabled: roundIsSelectedStored, paramRoundTo: roundValueStored });
    } else if (typeSurebet !== "bonus_bookmaker") {
      if (indexBookmakerSelectedStored >= 0) {
        stakeChangeNormalSurebet(indexBookmakerSelectedStored, dataOperation[indexBookmakerSelectedStored]["stake"], false, false, 0, dataOperation, indexBookmakerSelectedStored, roundIsSelectedStored, roundValueStored);
        setIsBlockedFieldsCash(true);
      } else {
        const newBudget = dataOperation.reduce(
          (sum, operation) => sum + operation.stake,
          0
        );
        setBudget(+newBudget.toFixed(2));
        calculateSurebet({ paramBudget: newBudget, paramRoundTo: roundValueStored, paramRoundingEnabled: roundIsSelectedStored });
      }
    }
  }, []);
  const handlerCommission = (index, value) => {
    const updated = [...dataOperation];
    updated[index]["commission"] = value;
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ dataOperationFreeBookmaker: updated });
    } else if (typeSurebet === "risk_free_betting") {
      if (updated.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramBookmakers: updated });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: updated });
    } else if (typeSurebet !== "bonus_bookmaker") {
      managerCalcSurebetPinnedStake(updated);
    }
  };
  const handlerBudget = (value) => {
    if (typeSurebet !== "bonus_bookmaker" && typeSurebet !== "risk_free_betting" && typeSurebet !== "locked_value") {
      setBudget(+value.toFixed(2));
      calculateSurebet({ "paramBudget": value });
    }
  };
  const setValueOption = (index, field, value) => {
    if (field === "chance") {
      handleChanceChange(index, value);
    } else if (field === "stake") {
      handleStakeChange(index, value);
    } else if (field === "commission") {
      handlerCommission(index, value);
    } else if (field === "backStake") {
      changeValeuBackStake(index, value);
    } else if (field === "budget") {
      handlerBudget(value);
    }
  };
  const increaseField = (index, field, quantity_increment) => {
    if (field === "budget") {
      let budgetSum = +(budget + quantity_increment).toFixed(2);
      setValueOption(-999, "budget", budgetSum);
      return;
    }
    let valueSum = +(dataOperation[index][field] + quantity_increment).toFixed(2);
    setValueOption(index, field, valueSum);
  };
  const decreaseField = (index, field, quantity_increment) => {
    if (field === "budget") {
      let budgetDecremented = +(budget - quantity_increment).toFixed(2);
      setValueOption(-999, "budget", budgetDecremented);
      return;
    }
    let valueDecremented = +(dataOperation[index][field] - quantity_increment).toFixed(2);
    setValueOption(index, field, valueDecremented);
  };
  function changeValeuBackStake(index, value) {
    let newStakeValue = +(value * (dataOperation[index].chance - 1)).toFixed(2);
    handleStakeChange(index, newStakeValue, false, true, value);
  }
  const handleInputEdition = (index, field, eventValue) => {
    const key = `${index}-${field}`;
    setEditingValues({ [key]: eventValue });
  };
  function changeInputValueBackStake(e, index) {
    const { value } = e.target;
    let backStakeNewValue = value === "," || value === "." ? 0 : parseBrazilianNumber(value, dataOperation[index].backStake);
    if (backStakeNewValue !== dataOperation[index].backStake) {
      changeValeuBackStake(index, backStakeNewValue);
    }
    ;
  }
  function helperInputCommission(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newCommission = parseBrazilianNumber(e.target.value, operation.commission);
      handleInputEdition(index, "commission", value);
      setValueOption(index, "commission", newCommission);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "commission", value);
      setValueOption(index, "commission", 0);
    }
  }
  function helperInputChance(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newChance = parseBrazilianNumber(e.target.value, operation.chance);
      handleInputEdition(index, "chance", value);
      setValueOption(index, "chance", newChance);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "chance", value);
      setValueOption(index, "chance", 0);
    }
  }
  function helperInputStake(e, index, operation) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      const newStake = parseBrazilianNumber(e.target.value, operation.chance);
      handleInputEdition(index, "stake", value);
      setValueOption(index, "stake", newStake);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "stake", value);
      setValueOption(index, "stake", 0);
    }
  }
  function helperInputBackStake(e, index) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      handleInputEdition(index, "backStake", value);
      changeInputValueBackStake(e, index);
    } else if (value === "," || value === ".") {
      handleInputEdition(index, "backStake", value);
      changeValeuBackStake(index, 0);
    }
  }
  function helperInputBudget(e) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      let newBudget = parseBrazilianNumber(e.target.value, budget);
      handleInputEdition(-999, "budget", value);
      setValueOption(-999, "budget", newBudget);
    } else if (value === "," || value === ".") {
      handleInputEdition(-999, "budget", value);
      setValueOption(-999, "budget", 0);
    }
  }
  function helperInputRound(e) {
    const { value } = e.target;
    let xyz = IsNumber(value);
    if (xyz === true) {
      setEditingRoundTo(value);
      setEditingValues({});
      let newRoundTo = parseBrazilianNumber(e.target.value, roundTo);
      setRoundTo(newRoundTo);
      if (typeSurebet === "bonus_bookmaker") {
        calculatreBonusBookmakerAndSurebet({ "paramRoundTo": newRoundTo });
      } else if (typeSurebet === "risk_free_betting") {
        if (dataOperation.length > 0) {
          managerCalcRiskFreeBettingFormula({ paramRoundTo: newRoundTo });
        }
      } else if (typeSurebet === "locked_value") {
        manageSurebetLockedValueFormula({ paramRoundTo: newRoundTo });
      } else {
        if (selectedBookmaker >= 0) {
          stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, true, newRoundTo);
        } else {
          calculateSurebet({ "paramRoundTo": newRoundTo });
        }
      }
    } else if (value === "," || value === ".") {
      setEditingRoundTo(value);
      setEditingValues({});
      setRoundTo(0);
      if (typeSurebet === "bonus_bookmaker") {
        calculatreBonusBookmakerAndSurebet({ "paramRoundTo": 0 });
      } else if (typeSurebet === "risk_free_betting") {
        if (dataOperation.length > 0) {
          managerCalcRiskFreeBettingFormula({ paramRoundTo: 0 });
        }
      } else if (typeSurebet === "locked_value") {
        manageSurebetLockedValueFormula({ paramRoundTo: 0 });
      } else {
        if (selectedBookmaker >= 0) {
          stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, true, 0);
        } else {
          calculateSurebet({ "paramRoundTo": 0 });
        }
      }
    }
  }
  function manageEventInputRoundingEnabled(e) {
    const { checked } = e.target;
    setEditingValues({});
    setRoundingEnabled(checked);
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({ "paramRoundingEnabled": checked });
    } else if (typeSurebet === "risk_free_betting") {
      if (dataOperation.length > 0) {
        managerCalcRiskFreeBettingFormula({ paramRoundingEnabled: checked });
      }
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramRoundingEnabled: checked });
    } else {
      if (selectedBookmaker >= 0) {
        stakeChangeNormalSurebet(selectedBookmaker, dataOperation[selectedBookmaker]["stake"], false, false, 0, dataOperation, selectedBookmaker, checked, roundTo);
      } else {
        calculateSurebet({ "paramRoundingEnabled": checked });
      }
    }
  }
  useEffect(() => {
    const hasInvalid = dataOperation.some(
      (bet, index) => {
        const key = `${index}-stake`;
        return bet.chance < 1 || bet.commission < -40 || bet.stake < 0 || bet.backStake < 0 || editingValues[key] !== void 0 && editingValues[key].length === 0;
      }
    ) || budget < 0 || roundTo <= 0;
    if (hasInvalid && !valueIsUnacceptable) {
      setValueIsUnacceptable(true);
    } else if (!hasInvalid && valueIsUnacceptable) {
      setValueIsUnacceptable(false);
    }
  }, [dataOperation, budget, roundTo]);
  return (
        <>

            {
                isMobile === true ?
                    <Mobile
                        dataOperation={dataOperation}
                        formData={formData}
                        typeSurebet={typeSurebet}
                        handleStakeChange={handleStakeChange}
                        calculateSurebet={calculateSurebet}

                        helperInputChance={helperInputChance}
                        helperInputStake={helperInputStake}
                        helperInputBackStake={helperInputBackStake}
                        helperInputCommission={helperInputCommission}
                        helperInputBudget={helperInputBudget}
                        helperInputRound={helperInputRound}
                        isBlockedFieldsCash={isBlockedFieldsCash}
                        manageEventInputRoundingEnabled={manageEventInputRoundingEnabled}
                    />
                    :
                    <Desktop
                        dataOperation={dataOperation}
                        formData={formData}
                        typeSurebet={typeSurebet}
                        calculateSurebet={calculateSurebet}
                        setValueOption={setValueOption}
                        increaseField={increaseField}
                        decreaseField={decreaseField}
                        handleStakeChange={handleStakeChange}
                        helperInputChance={helperInputChance}
                        helperInputStake={helperInputStake}
                        helperInputBackStake={helperInputBackStake}
                        helperInputCommission={helperInputCommission}
                        helperInputBudget={helperInputBudget}
                        helperInputRound={helperInputRound}
                        handleInputEdition={handleInputEdition}
                        isBlockedFieldsCash={isBlockedFieldsCash}
                        manageEventInputRoundingEnabled={manageEventInputRoundingEnabled}
                    />
            }

        </>
    );
}
var User_default = User;
export {
  User_default as default
};